import {React, useState, useEffect} from 'react';
import jawlogo from '../../Images/ja-logo.jpeg';
import batterylogo from '../../Images/batteries-logo.jpg';
import battery1 from '../../Images/battery-1.jpeg';
import battery2 from '../../Images/battery-2.jpeg';
import battery3 from '../../Images/battery-3.jpeg';
import battery4 from '../../Images/battery-4.jpeg';
import battery6 from '../../Images/battery-6.jpeg';
import { FaPhoneAlt, FaEnvelope, FaTimes, FaClock } from 'react-icons/fa';

// Placeholder images for the gallery and QR codes.
// Replace these with your actual image imports.
const galleryImages = [
 battery1,
 battery2,
 battery3,
 battery4,
 battery3,
 battery6,
];

const qrCodeHospet = 'https://via.placeholder.com/150';
const qrCodeChitradurga = 'https://via.placeholder.com/150';

const API_BASE_URL = (process.env.NODE_ENV === 'production' ? 'https://japl-backend-v2jm.onrender.com/api' : 'http://localhost:5000/api')
// const API_BASE_URL = 'http://localhost:5000/api'


const JAW_TATABATTERIES = () => {

   // State for backend QR URLs for RANE sub-branches
      const [qrHospet, setQrHospet] = useState(null);
    
      // Fetch QR for RANE Hospet and Chitradurga on mount
      useEffect(() => {
        async function fetchQRs() {
          try {
            const res1 = await fetch(`${API_BASE_URL}/branchqrcode/Tata Batteries::Hospet`);
            if (res1.ok) {
              const data1 = await res1.json();
              setQrHospet(data1.qrCodeImageURL.startsWith('http') ? data1.qrCodeImageURL : `https://japl-backend-v2jm.onrender.com/${data1.qrCodeImageURL.replace(/^\//, '')}`);
            } else {
              setQrHospet(null);
            }

          } catch {
            setQrHospet(null);
          }
        }
        fetchQRs();
      }, []);

  return (
    <div className=''>
      <section className="relative h-[390px] md:h-[370px] lg:h-[400px] w-full flex items-center justify-center overflow-hidden">
    {/* Background image */}
    <img
      src={battery1}
      alt="Engine Workshop Background"
      className="absolute inset-0 w-full h-[390px] md:h-[370px] lg:h-[400px] object-cover object-center"
      style={{ zIndex: 1 }}
    />
    {/* Backdrop overlay for readability */}
    <div
      className="absolute inset-0 h-[390px] md:h-[370px] lg:h-[400px] bg-black/30"
      style={{ zIndex: 2 }}
    />

    {/* Content Row */}
    <div className="relative z-10 flex flex-col items-center justify-center w-full max-w-6xl px-6 pt-4">
      {/* Logo */}
      <div className="flex flex-col items-center justify-center text-white w-full">
        <img
          src={jawlogo}
          alt="JAW Logo"
          className="w-20 h-20 object-cover drop-shadow-xl rounded-full mx-auto sm:mx-0"
        />
      </div>

      {/* Headings */}
      <h1 className="text-white text-3xl md:text-5xl font-bold tracking-tight leading-tight text-center drop-shadow-lg mt-4">
        JANATHA ENTERPRISES
      </h1>
      <div className="bg-red-500 p-2 text-center rounded-xl mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full">
        AUTHORIZED CUMMINS DISTRIBUTOR (CCC)
      </div>
      <div className="mt-4 text-lg md:text-xl font-semibold text-white drop-shadow-sm max-w-full text-center">
        Powering Performance with Precision
      </div>
    </div>
  </section>
      
      {/* Description Section */}
      <div className='pt-12 mx-auto px-4 sm:px-8 md:px-12 lg:px-20'>
       <div className='flex items-center justify-center'>
         <img src={batterylogo} alt="battery-logo" className='h-16 md:h-24 content-center pb-4' />
       </div>
        <div className='flex flex-col md:flex-row items-center justify-center gap-4 text-center md:text-left'>
          <h2 className=' text-center text-2xl md:text-4xl  font-bold text-gray-900 font-sans mt-4 md:mt-0'>Power You Can Trust – Our Partnership with
 <br /> Tata Green Batteries</h2>
 <div className='border-b border-green-500 '></div>
        </div>
        <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700'>
     At Janatha Automotives, reliability is the foundation of our service. In line with that commitment, we are proud to be an Authorized Sales and Service Dealer for Tata Batteries—a brand synonymous with performance, durability, and trusted power solutions across India.
        </p>
        <p className='px-4 md:px-20 text-center text-sm md:text-lg lg:text-xl pt-4 text-gray-700'>
    As official Tata Green Battery distributors, we deliver genuine power solutions with certified expertise. From personal vehicles to industrial equipment, we provide reliable energy solutions backed by Tata's legacy of trust.
    </p>
      </div>

      {/* 3-Cards Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 py-12'>
        {/* Card 1 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={battery1} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Genuine Tata Products</h3>
          <p className='text-center text-sm md:text-base'>100% authentic batteries with full warranty coverage.</p>
        </div>

        {/* Card 2 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={battery2} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Expert Installation</h3>
          <p className='text-center text-sm md:text-base'>Factory-trained technicians for perfect fitment.</p>
        </div>

        {/* Card 3 */}
        <div className='border border-gray-200 p-4 rounded-xl shadow-lg'>
          <img src={battery3} alt="rane image" className='w-full h-48 md:h-64 object-cover rounded-xl' />
          <h3 className='text-lg md:text-xl font-semibold text-center py-2'>Contact Our Expert</h3>
          <p className='text-center text-sm md:text-base'>Emergency battery replacement across districts.</p>
        </div>
      </div>

      {/* Commitment Section */}
      <div className='grid grid-cols-1 md:grid-cols-2 p-8 gap-6 mx-4 sm:mx-8 md:mx-12 lg:mx-20 shadow-2xl rounded-lg bg-gray-50'>
        <div className='space-y-4'>
          <h3 className='text-2xl md:text-3xl font-semibold text-gray-800'>Why Tata Batteries at Janatha?</h3>
          <ul className='space-y-2 text-sm md:text-base text-gray-600'>
            <li><span className='text-green-500'>✓</span> Official distributor for Hospet, Raichur & Bellary</li>
            <li><span className='text-green-500'>✓</span> Direct technical support from Tata AutoComp</li>
            <li><span className='text-green-500'>✓</span> Complete range of automotive & industrial batteries</li>
            <li><span className='text-green-500'>✓</span> On-site delivery and installation services</li>
          </ul>
        </div>
        <div>
          <img src={battery4} alt="rane-4" className='w-full h-48 md:h-72 object-cover rounded-xl' />
        </div>
      </div>
      
      {/* Gallery Section */}
      <div className='py-12 mx-4 sm:mx-8 md:mx-12 lg:mx-20 pt-12'>
        <h2 className='text-3xl md:text-4xl font-bold text-center mb-8 text-gray-900'>Gallery</h2>
        <div className='grid grid-cols-2 md:grid-cols-3  gap-4'>
          {galleryImages.map((image, index) => (
            <div key={index} className='overflow-hidden rounded-lg shadow-lg transform transition-transform duration-300 hover:scale-105'>
              <img src={image} alt={`Gallery image ${index + 1}`} className='w-full h-40 md:h-52 object-cover' />
            </div>
          ))}
        </div>
      </div>

      {/* Contact/Footer Section as per image */}
      <div className='py-12 bg-gray-900 text-white text-center px-4 sm:px-8 md:px-12 lg:px-20'>
        <div className='max-w-4xl mx-auto'>
          <h2 className='text-2xl md:text-3xl lg:text-4xl font-bold pt-4 font-sans mb-2 text-green-500'>Power Your Journey</h2>
          <p className='text-sm md:text-base text-gray-300 mb-8'>
           Need genuine batteries, emergency support, or expert advice?
          </p>
        </div>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
          {/* Card 1: Contact Information */}
          <div className='bg-gray-800 p-6 rounded-lg shadow-lg'>
            <h3 className='text-xl font-bold mb-4'>CONTACT INFORMATION</h3>
            <div className='space-y-4 text-left'>
              <div>
                <p className='text-sm font-semibold mb-1 text-green-300'>Hospet</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaPhoneAlt className='text-green-400' />
                  <span className='text-green-400'>9591080008</span>
                </div>
                <div className='flex items-center space-x-2 text-gray-400 mt-1'>
                  <FaEnvelope className='text-green-400' />
                  <span className='text-green-400'>jawtatagreen@gmail.com</span>
                </div>
              </div>
              <hr className='border-gray-700' />
              <div>
                <p className='text-sm font-semibold mb-1 text-green-400'>Business Hours</p>
                <div className='flex items-center space-x-2 text-gray-400'>
                  <FaClock className='text-green-400' />
                  <span>Monday - Saturday : 10:00 AM to 6:30 PM</span>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Hospet Address */}
          <div className='bg-gradient-to-br from-green-900/50 to-green-800/50 p-6 rounded-lg shadow-lg flex flex-col items-center justify-center'>
            <h3 className='text-xl font-bold mb-4'>HOSPET Head Office</h3>
            <p className='text-sm text-gray-400 mb-4'>Scan for directions</p>
           <img
              src={qrHospet || qrCodeHospet}
              alt="QR Code Hospet"
              className='w-40 h-40 rounded-lg bg-white'
            />
            <p className='mt-4 text-sm text-gray-400'>Janatha Auto Works, #10, Janatha Complex, Hampi Road, Near Bala Talkies, Hospet - 58320</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JAW_TATABATTERIES;